
define('ldsh!modules/form_editor/templates/input_check_item_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<input type="checkbox"\n  on="change:AMP.setState({\n       ' +
((__t = ( ampStateId )) == null ? '' : __t) +
': {\n          choiceChecked: event.checked == true ?\n          ' +
((__t = ( ampStateId )) == null ? '' : __t) +
'.choiceChecked + 1 :\n          ' +
((__t = ( ampStateId )) == null ? '' : __t) +
'.choiceChecked - 1\n       }\n  })"\n  class="' +
((__t = ( isRequired ? 'form-element-required': '' )) == null ? '' : __t) +
'"\n  name="' +
((__t = ( inputName )) == null ? '' : __t) +
'[]"\n  value="' +
((__t = ( value )) == null ? '' : __t) +
'"\n  id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n  ' +
((__t = ( selected ? "checked" : "" )) == null ? '' : __t) +
'\n/> ' +
((__t = ( parsedText )) == null ? '' : __t) +
'\n';

}
return __p
};});

